module.exports = __webpack_public_path__ + "static/media/je.d85a7691.svg";